import {CompetitorHighlightsPageRouteMetaDataModel} from "./competitor.highlights-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitorPageRouteConfig} from "../../../models/competitor.page-route.config";

export class CompetitorHighlightsPageRouteConfig extends CompetitorPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITOR.highlights,
      path: `highlights`,
      componentImport: () => import("../components/competitor.highlights-page" /* webpackChunkName: "competitor.highlights-page" */ ),
      metadataType: CompetitorHighlightsPageRouteMetaDataModel
    });
  }
}
